module.exports = __webpack_public_path__ + "static/media/nav4.b41b5bdf.svg";